import script from "./MenuDropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuDropDown.vue?vue&type=script&setup=true&lang=js"

import "./MenuDropDown.vue?vue&type=style&index=0&id=7529baf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7529baf6"]])

export default __exports__